import { render, staticRenderFns } from "./LayoutApplicationPayment.vue?vue&type=template&id=804f4560&scoped=true&"
import script from "./LayoutApplicationPayment.vue?vue&type=script&lang=js&"
export * from "./LayoutApplicationPayment.vue?vue&type=script&lang=js&"
import style0 from "./LayoutApplicationPayment.vue?vue&type=style&index=0&id=804f4560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804f4560",
  null
  
)

export default component.exports